module.exports = __webpack_public_path__ + "static/img/strawberry_th.01c6399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/strawberry_th.png
// module id = oSwA
// module chunks = 0